import React from "react";
import styles from "./Destinations7.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations7 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Duplicate array for seamless scrolling
  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.mainTitle}>Next Stop</h2>
        <div className={styles.subLine}>
          <span className={styles.decorator}></span>
          <p className={styles.lead}>Breaking the boundaries of typical travel</p>
        </div>
      </div>

      <div className={styles.outerTrack}>
        <div className={styles.track}>
          {scrollItems.map((dest, index) => {

            const fallbackImage =
              fallbackImages[index % fallbackImages.length];

            const imageUrl =
              dest?.image && dest.image.trim() !== ""
                ? dest.image
                : fallbackImage;

            return (
              <div key={index} className={styles.card}>
                <div className={styles.skewWrapper}>
                  <div className={styles.imageBox}>
                    <img
                      src={imageUrl}
                      alt={dest?.name || "Destination"}
                      className={styles.image}
                      onError={(e) => {
                        e.target.src = fallbackImage;
                      }}
                    />

                    <div className={styles.colorBlock}></div>
                  </div>
                </div>

                <div className={styles.content}>
                  <h3 className={styles.cardTitle}>
                    {dest?.name || "Explore Destination"}
                  </h3>

                  <div className={styles.viewMore}>
                    <span>Explore</span>
                    <div className={styles.arrow}>→</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Destinations7;